// Core packages
import { Injectable } from "@angular/core";

// Third party packages
import { BehaviorSubject } from "rxjs";

// Custom packages
import { ListSetting } from "src/app/shared/interfaces/list-setting.interface";

@Injectable({
  providedIn: "root"
})
export class ListsService {
  listsSettings$: BehaviorSubject<ListSetting[]> = new BehaviorSubject([]);
  private listSettings: ListSetting[] = [];
  private disabled = false;

  /**
   * Class constructor
   */
  // constructor() {}

  /**
   * Create a new listSetting with given value and check if
   * created listSetting is a new one or an update of an exising
   * one and than perform the add/update operation. Then
   * emit new value for listSettings$ BehaviorSubject()
   *
   * @since 1.0.0
   *
   * @param name Name of the settings. Usually the plural of the referral module
   * @param pageIndex Current page index
   * @param pageSize Current page size
   */
  setListSetting(
    name: string,
    pageIndex: number,
    pageSize: number,
    search: any,
  ): void {
    if (this.disabled) {
      return;
    }

    const newSetting: ListSetting = {
      name,
      pageIndex,
      pageSize,
      search
    };

    const listSettingExists = this.listSettings.find(
      setting => setting.name === name
    );
    if (listSettingExists) {
      this.updateListSetting(newSetting);
    } else {
      this.addNewSetting(newSetting);
    }
  }

  /**
   * Updates an existing setting with new values
   * and emit a new value to the BehaviorSubject()
   *
   * @since 1.0.0
   */
  updateListSetting(newSetting: ListSetting): void {
    this.listSettings.map(setting => {
      if (setting.name === newSetting.name) {
        Object.assign(setting, newSetting);
      }
    });
    this.listsSettings$.next(this.listSettings);
  }

  /**
   * Add a new setting to the settings' list
   * and emit a new value to the BehaviorSubject()
   *
   * @since 1.0.0
   */
  addNewSetting(newSetting: ListSetting): void {
    this.listSettings.push(newSetting);
    this.listsSettings$.next(this.listSettings);
  }

  /**
   * Reset all settings
   *
   * @since 1.0.0
   */
  resetAllSettings(): void {
    this.listSettings.map((setting: ListSetting) => {
      setting.pageIndex = 0;
      setting.pageSize = 10;
      Object.keys(setting.search).forEach((settingKey: string) => {
        setting.search[settingKey] = "";
      });
      return setting;
    });

    this.listsSettings$.next(this.listSettings);
    this.disable();
  }

  /**
   * Enable list setting
   *
   * @since 1.0.0
   */
  enable(): void {
    this.disabled = false;
  }

  /**
   * Disable list setting
   *
   * @since 1.0.0
   */
  disable(): void {
    this.disabled = true;
  }
}
